const PopupComponent = ({phonicPopup}) => {

  const tableData = [
    { id: 'A', value: 'April' },
    { id: 'B', value: 'Bengal' },
    { id: 'C', value: 'Calendar' },
    { id: 'D', value: 'Delhi' },
    { id: 'E', value: 'Eastern' },
    { id: 'F', value: 'February' },
    { id: 'G', value: 'Gujarat' },
    { id: 'H', value: 'Himachal' },
    { id: 'I', value: 'India' },
    { id: 'J', value: 'January' },
    { id: 'K', value: 'Karnataka' },
    { id: 'L', value: 'Lucknow' },
    { id: 'M', value: 'March' },
    { id: 'N', value: 'November' },
    { id: 'O', value: 'October' },
    { id: 'P', value: 'Papa' },
    { id: 'Q', value: 'Query' },
    { id: 'R', value: 'Rain' },
    { id: 'S', value: 'September' },
    { id: 'T', value: 'Time' },
    { id: 'U', value: 'Uniform' },
    { id: 'V', value: 'Victory' },
    { id: 'W', value: 'Whistle' },
    { id: 'X', value: 'X-Ray' },
    { id: 'Y', value: 'Yahoo' },
    { id: 'Z', value: 'Zebra' },
  ];

  return (
    <div>
      {phonicPopup && (
        <div className="phonic-table">
            <table>
                <thead>
                    <th className="table-cell">Letter</th>
                    <th className="table-cell">Phonic</th>
                </thead>
                <tbody>
                {tableData.map(item => (
                    <tr key={item.id} className="table-row content-row">
                    <td className="table-cell">{item.id}</td>
                    <td className="table-cell">{item.value}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
      )}
    </div>
  );
};

export default PopupComponent;
